import { FC, useState } from "react";
import styles from "./CookieRow.module.scss";
import { Link } from "react-router-dom";
import { Button, PATHNAMES } from "@/shared";

export const CookieRow: FC = () => {
  const [show, setShow] = useState<boolean>(true);

  const handleClick = () => {
    document.cookie = `accepted-cookie=1; path=/;`;
    setShow(false);
  };
  return show ? (
    <div className={styles.rowMain}>
      <div>
        Мы используем cookie. Оставаясь с нами, вы соглашаетесь на их
        применение.&nbsp;
        <Link target="_blank" to={PATHNAMES.cookiePage}>
          Подробнее
        </Link>
      </div>

      <Button buttontStyle="noBG" name="ОК" onClick={handleClick} />
    </div>
  ) : (
    <></>
  );
};
